import { Field, YesNoToggle } from "../formHelpers";

const LIFESTYLE_ITEMS = [
  {
    key: "drinking",
    label: "Drinking",
    qtyLabel: "Quantity per week",
    qtyKey: "quantity",
    qtyPlaceholder: "e.g. 2 pegs / week",
  },
  {
    key: "smoking",
    label: "Smoking",
    qtyLabel: "Sticks per day",
    qtyKey: "sticksPerDay",
    qtyPlaceholder: "e.g. 5",
  },
  {
    key: "chewing",
    label: "Chewing tobacco / pan masala",
    qtyLabel: "Product name",
    qtyKey: "product",
    qtyPlaceholder: "e.g. Rajnigandha",
  },
];

function LifestyleRow({ mKey, item, value, errors, setIns }) {
  const { key: lk, label, qtyLabel, qtyKey, qtyPlaceholder } = item;
  const l = value || { status: "no" };

  return (
    <div className="mb-5 last:mb-0">
      <div className="flex items-center justify-between gap-3 mb-2">
        <span className="text-sm">{label}</span>
        <YesNoToggle
          value={l.status}
          onChange={(v) => setIns(mKey, `lifestyle.${lk}.status`, v)}
          testIdBase={`ls-${lk}-${mKey}`}
        />
      </div>
      {l.status === "yes" && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3">
          <Field
            label="Since when"
            testId={`${lk}-since-${mKey}`}
            error={errors[`${mKey}-${lk}-since`]}
          >
            <input
              type="text"
              value={l.since || ""}
              onChange={(e) => setIns(mKey, `lifestyle.${lk}.since`, e.target.value)}
              className={`form-input ${errors[`${mKey}-${lk}-since`] ? "error" : ""}`}
              placeholder="e.g. 2018"
              data-testid={`input-${lk}-since-${mKey}`}
            />
          </Field>
          <Field
            label={qtyLabel}
            testId={`${lk}-qty-${mKey}`}
            error={errors[`${mKey}-${lk}-qty`]}
          >
            <input
              type="text"
              value={l[qtyKey] || ""}
              onChange={(e) => setIns(mKey, `lifestyle.${lk}.${qtyKey}`, e.target.value)}
              className={`form-input ${errors[`${mKey}-${lk}-qty`] ? "error" : ""}`}
              placeholder={qtyPlaceholder}
              data-testid={`input-${lk}-qty-${mKey}`}
            />
          </Field>
        </div>
      )}
    </div>
  );
}

export default function LifestyleSection({ mKey, ls, errors, setIns }) {
  return (
    <div className="mt-6 pt-6 border-t border-subtle">
      <p className="text-sm font-semibold text-secondary-brand mb-4 uppercase tracking-wider">
        Lifestyle
      </p>
      {LIFESTYLE_ITEMS.map((item) => (
        <LifestyleRow
          key={item.key}
          mKey={mKey}
          item={item}
          value={ls?.[item.key]}
          errors={errors}
          setIns={setIns}
        />
      ))}
    </div>
  );
}
